<div class="innerpage-fullwithbanner">
  <h2 class="bighead">Offers</h2>
  <ul class="bread-crumbs">
    <li><a (click)="_validationService.redirect('/')">Home<span>|</span></a></li>
    <li *ngIf="currentMenu!=''"><span>{{currentMenu}}<span style="padding:8px;">|</span></span></li>
    <li>Offers</li>
  </ul>
</div>
<div class="featuredproperties section-margin">
  <div class="container container-lg min-heightcontainer">
    <div class="border-div table-fixed margin0">
      <div class="tabstyle2 offerdetailstab-padding pos-relative">

        <ul class="switchingproperty margin-bottom-15 offerlistingtab offerlisTingtab">
          <li [class.active]="currentTab === propertyType.Exchange1031">
            <a href="javascript:void(0);" (click)="onTabClick(propertyType.Exchange1031)">
              1031 Exchange
              <span *ngIf="currentTab === propertyType.Exchange1031;" class="countstyle">{{exchange1031Count}}</span>
            </a>
          </li>
          <li [class.active]="currentTab === propertyType.Sale">
            <a href="javascript:void(0);" (click)="onTabClick(propertyType.Sale)">
              B+E Listing
              <span *ngIf="currentTab === propertyType.Sale;" class="countstyle">{{saleCount}}</span>
            </a>
          </li>
        </ul>
        <div class="absolutesearch">
          <div class="floatinghead clearfix">
            <div class="rightside clearfix">
              <div class="search-sec ">
                <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search">
                <i class="fa fa-search icon" aria-hidden="true"></i>
              </div>
              <!--<a class="filter btn  btn-circle btn-green adduserbtn" href="javascript:void(0);" tooltip="Filter"><i aria-hidden="true" class="fa fa-filter icon"></i></a>-->
            </div>
          </div>
        </div>
        <div class="">
          <div class="form-group">
            <ul class="statuslisting">
              <li class="transition noactivity offers-no-activity" [class.active]="activefilterButton === offerStatus.NoActivitySinceLast10Days" (click)="filterByStatus(offerStatus.NoActivitySinceLast10Days,$event)">
                <a href="javascript:void(0);" class="toparrangement">
                  <h3>{{NoActivitySinceLast10Days}}</h3>
                  <h4>No activity<span>since last 10 days</span></h4>
                </a>
              </li>
              <li class="transition greenbg offers-loi-in-progress" style="background:rgba(25, 143, 222, 0.68)">
                <a href="javascript:void(0);">
                  <h3>{{_validationService.formatNumberToTwoDigit(_validationService.ConvertToInt(New) + _validationService.ConvertToInt(OfferModified) +_validationService.ConvertToInt(Countered))}}</h3>
                </a>
                <div class="displayinlineblockdiv">
                  <a href="javascript:void(0);">
                    <h4>LOI in Progress</h4>
                  </a>
                  <h5>
                    <a href="javascript:void(0);" [class.active]="activefilterButton === offerStatus.New" (click)="filterByStatus(offerStatus.New,$event)"><span [class.active]="activefilterButton === offerStatus.New">{{New}}</span> New</a>
                    <a href="javascript:void(0);" [class.active]="activefilterButton === offerStatus.OfferModified" (click)="filterByStatus(offerStatus.OfferModified,$event)"><span>{{OfferModified}}</span> Modified</a>
                    <a href="javascript:void(0);" [class.active]="activefilterButton === offerStatus.Countered" (click)="filterByStatus(offerStatus.Countered,$event)"><span>{{Countered}}</span> Countered</a>
                  </h5>
                </div>

              </li>
              <li class="transition greenbg offers-deals-in-progress">
                <a href="javascript:void(0);">
                  <h3>{{_validationService.formatNumberToTwoDigit(_validationService.ConvertToInt(HardContract) + _validationService.ConvertToInt(UnderContract))}}</h3>
                </a>
                <div class="displayinlineblockdiv">
                  <a href="javascript:void(0);">
                    <h4>Deals in progress</h4>
                  </a>
                  <h5>
                    <a href="javascript:void(0);" [class.active]="activefilterButton === offerStatus.UnderContract" (click)="filterByStatus(offerStatus.UnderContract,$event)"><span>{{UnderContract}}</span> Under Contract</a>
                    <a href="javascript:void(0);" [class.active]="activefilterButton === offerStatus.HardContract" (click)="filterByStatus(offerStatus.HardContract,$event)"><span>{{HardContract}}</span> Hard Contract</a>
                  </h5>
                </div>

              </li>
              <li class="transition closed offers-closed" [class.active]="activefilterButton === offerStatus.Closed" (click)="filterByStatus(offerStatus.Closed,$event)">
                <a href="javascript:void(0);">
                  <h3>{{Closed}}</h3>
                  <h4>Closed</h4>
                </a>
              </li>
              <!--<li class="transition" [class.active]="activefilterButton === offerStatus.New" (click)="filterByStatus(offerStatus.New,$event)">
                  <a href="javascript:void(0);">
                      <h3 style="color:#2695DF">{{New}}</h3>
                      <h4>New / Modified</h4>
                  </a>
              </li>
              <li class="transition" [class.active]="activefilterButton === offerStatus.Reviewed" (click)="filterByStatus(offerStatus.Reviewed,$event)">
                  <a href="javascript:void(0);">
                      <h3 style="color:#063D5B">{{Reviewed}}</h3>
                      <h4>Reviewed</h4>
                  </a>
              </li>
              <li class="transition" [class.active]="activefilterButton === offerStatus.Countered" (click)="filterByStatus(offerStatus.Countered,$event)">
                  <a href="javascript:void(0);">
                      <h3 style="color:#063D5B">{{Countered}}</h3>
                      <h4>Countered</h4>
                  </a>
              </li>
              <li class="transition" [class.active]="activefilterButton === offerStatus.CounterAccepted" (click)="filterByStatus(offerStatus.CounterAccepted,$event)">
                  <a href="javascript:void(0);">
                      <h3 style="color:#28A436">{{CounterAccepted}}</h3>
                      <h4>Counter Accepted</h4>
                  </a>
              </li>
              <li class="transition" [class.active]="activefilterButton === offerStatus.CounterDeclined" (click)="filterByStatus(offerStatus.CounterDeclined,$event)">
                  <a href="javascript:void(0);">
                      <h3 style="color:#F5A623">{{CounterDeclined}}</h3>
                      <h4>Counter Declined</h4>
                  </a>
              </li>
              <li class="transition" [class.active]="activefilterButton === offerStatus.OfferAccepted" (click)="filterByStatus(offerStatus.OfferAccepted,$event)">
                  <a href="javascript:void(0);">
                      <h3 style="color:#ad1f16">{{OfferAccepted}}</h3>
                      <h4>Offer Accepted</h4>
                  </a>
              </li>
              <li class="transition" [class.active]="activefilterButton === offerStatus.UnderContract" (click)="filterByStatus(offerStatus.UnderContract,$event)">
                  <a href="javascript:void(0);">
                      <h3 style="color:#8756B2">{{UnderContract}}</h3>
                      <h4>Under Contract</h4>
                  </a>
              </li>
              <li class="transition" [class.active]="activefilterButton === offerStatus.HardContract" (click)="filterByStatus(offerStatus.HardContract,$event)">
                  <a href="javascript:void(0);">
                      <h3 style="color:#8756B2">{{HardContract}}</h3>
                      <h4>Hard Contract</h4>
                  </a>
              </li>

              <li class="transition" [class.active]="activefilterButton === offerStatus.Rejected" (click)="filterByStatus(offerStatus.Rejected,$event)">
                  <a href="javascript:void(0);">
                      <h3 style="color:#FB4338">{{Rejected}}</h3>
                      <h4>Rejected</h4>
                  </a>
              </li>

              <li class="transition" [class.active]="activefilterButton === offerStatus.Draft" *ngIf="loggedInUserRole !== userRole.Admin" (click)="filterByStatus(offerStatus.Draft,$event)">
                  <a href="javascript:void(0);">
                      <h3 style="color:#ad1f16">{{Draft}}</h3>
                      <h4>Draft</h4>
                  </a>
              </li>-->
              <li class="transition link-btn-li" (click)="filterByStatus(offerStatus.Reset,$event)">
                <a class="bluelinkunderline" href="javascript:void(0);">Reset</a>
              </li>
            </ul>
          </div>
          <div class="floatinghead offerlist-form  clearfix">
            <div class="left ">
              <!--<div class="margin-bottom-15  margin-right-10 displayinlineblockdiv">
                  <label class="select">
                      <select class="form-control" [(ngModel)]="selectedAction" (change)="onActionSelect($event,template,'deletemodal',ChangeStatus);">
                          <option value="0">--Select Actions--</option>
                          <option value="1">Delete</option>
                          <option value="2">Download LOI</option>
                          <option value="3">Change Status</option>
                      </select>
                      <i></i>
                  </label>
              </div>-->
              <!--<div class="form-radio displayinlineblockdiv">
                  <label class="radio radio-inline margin-bottom-15 margin-right-10">
                      <input type="radio" name="aa"> Group by properties
                      <i class="helper"></i>
                  </label>
                  <label class="radio radio-inline margin-bottom-15 margin-right-10">
                      <input type="radio" name="aa"> Group by exchange
                      <i class="helper"></i>
                  </label>
              </div>

              <div class="margin-bottom-15 margin-right-10 displayinlineblockdiv">
                  <label class="select">
                      <select class="form-control">
                          <option>Select property</option>
                      </select>
                      <i></i>
                  </label>
              </div>
              <div class="margin-bottom-15 margin-right-10 displayinlineblockdiv">
                  <label class="select">
                      <select class="form-control">
                          <option>Select exchange</option>
                      </select>
                      <i></i>
                  </label>
              </div>-->
            </div>
            <!--<div class="rightside clearfix">-->
            <!--<div class="search-sec ">
                <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search">
                <i class="fa fa-search icon" aria-hidden="true"></i>
            </div>-->
            <!--<a class="filter btn  btn-circle btn-green adduserbtn" href="javascript:void(0);" tooltip="Filter"><i aria-hidden="true" class="fa fa-filter icon"></i></a>-->
            <!--</div>-->
          </div>


          <div class="table-responsive">
            <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
              <thead>
                <tr>
                  <th style="width:100px" data-orderable="false">Action</th>
                  <th class="hide">Id</th>
                  <th class="hide"></th>
                  <th class="sticky-left z-100 min-width-75">Buyer Name</th>
                  <th class="min-width-td">Tenant</th>
                  <th class="min-width-60">Broker</th>
                  <th>Offer Date</th>
                  <th>Asking Price</th>
                  <th>Offer Price</th>
                  <th>Earnest Money Deposit</th>
                  <th>Due Diligence Period (Days)</th>
                  <th>Closing Period (Days)</th>
                  <th>Comments</th>
                  <th>Status</th>
                  <th></th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let offer of offers; let index=index">
                  <td class="hide">{{offer.LeadId}}</td>
                  <td class="hide">
                    <label class="custom-checkbox withoutlabel">
                      <input type="checkbox" [disabled]="offer.IsDraft" [(ngModel)]="offer.IsChecked" (change)="onCheckboxSelection(offer);" id="0" class="ng-pristine ng-valid ng-touched"><i></i>
                    </label>
                  </td>
                  <td class="whitespacenowrap">
                    <div class="d-flex">
                      <!--Removed  container="body"-->
                      <div class="btn-group rightdropdown" *ngIf="!offer.IsDraft && offer.StatusId !== 456 && offer.StatusId !== 464" dropdown>
                        <button id="button-basic" dropdownToggle type="button" class="blueone dropdown-toggle"
                                aria-controls="dropdown-basic">
                          <i class="fa fa-cog" aria-hidden="true"></i>
                        </button>
                        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic" style="left:0">
                          <li *ngFor="let stype of statusListFilter(offer.StatusId)"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(stype.id,offer.LeadId,offer.LeadGuid)">{{stype.description}}</a></li>
                        </ul>
                      </div>
                      <a class="bluetwo" [ngClass]="{'newnote': offer.UnReadNoteCount!=0}" tooltip="Notes" href="javascript:void(0);" (click)="openModalForNotes(notestemplate,'panlestyle sharednotesmodal',offer)">
                        <i class="icon-inquiry" aria-hidden="true"></i>
                      </a>
                      <a href="javascript:void(0);" *ngIf="((offer.CoBrokerId==user.Id && offer.StatusId != 457 && offer.StatusId != 464)||this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin))" routerLink="/place-offer/{{offer.PropertyGuid}}/{{offer.LeadGuid}}/{{fromPage}}" class="blueone" tooltip="Modify" placement="top">
                        <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
                      </a>
                      <a class="remove" *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)" tooltip="Remove" href="javascript:void(0);" (click)="openModal(template,'deletemodal',offer.LeadId,index)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                    </div>
                  </td>
                  <td class="sticky-left">
                    <p><a href="javascript:void(0);" routerLink="/offer-detail/{{offer.LeadGuid}}" [queryParams]="{prevroute:'Offers', link : 'offers-list?fromMenu=Opportunity'}">{{offer.LeadName}}</a></p>
                  </td>
                  <td>
                    <p>{{ (offer.TenantName!=null && offer.TenantName!=" ") ? (offer.TenantName) : "-" }}&nbsp;&nbsp;<span *ngIf="offer.Is1031" class="tag-1031">1031</span></p>
                  </td>
                  <td>
                    <p>{{ offer.PrimaryContactName }}</p>
                    <!--<p *ngIf="offer.SecondaryContactNames">{{ offer.SecondaryContactNames }}</p>-->
                  </td>
                  <td><span *ngIf="offer.OfferDate">{{convertUTCDateToLocalOfferDate(offer.OfferDate)| date:'MM/dd/yyyy'}}</span></td>
                  <td><p class="whitespacenowrap" *ngIf="offer.Unpriced">Unpriced</p>
                      <p class="whitespacenowrap" *ngIf="(!offer.Unpriced || offer.Unpriced == null || offer.Unpriced == 0)"> {{(offer.Price!=null&&offer.Price>=0) ? '$ '+(offer.Price |number:0) : '-'}}</p></td>
                  <td>
                    <p class="whitespacenowrap">
                      {{(offer.OfferPrice!=null&&offer.OfferPrice>=0) ? '$ '+(offer.OfferPrice |number:0) : '-'}}
                    </p>
                  </td>
                  <td><p class="whitespacenowrap">{{(offer.EarnestMoneyDeposit) ? '$ '+(offer.EarnestMoneyDeposit |number:0) : '-'}}</p></td>
                  <td>{{(offer.DueDiligencePeriod) ? (offer.DueDiligencePeriod | number:0) : '-'}}</td>
                  <td>{{(offer.ClosingPeriod) ? (offer.ClosingPeriod | number:0) : '-'}}</td>
                  <td>
                    <p class="ellipsis-text commentpara">
                      {{offer.Comments?.length > 15 ? (offer.Comments.substr(0,15) + '...') :  (offer.Comments ? (offer.Comments):'-')}}
                      <button *ngIf="offer.Comments?.length > 15" class="eyeicon" container="body" triggers="focus" popover="{{offer.Comments}}"><i class="fa fa-eye" aria-hidden="true"></i></button>
                    </p>
                  </td>
                  <!--<td>{{offer.StatusName}}</td>-->
                  <td class="whitespacenowrap">
                    <div>{{offer.StatusName=='Cancelled' ? 'Canceled' :offer.StatusName }}</div>
                    <span *ngIf="offer.IsDraft" class="red">(Draft)</span>
                    <!--<label class="select" *ngIf="!offer.IsDraft">
        <select class="form-control" [(ngModel)]="offer.StatusId" id="status" #status (change)="changeOfferStatus(offer.StatusId,offer.LeadId,offer.LeadGuid)">
            <option *ngFor="let stype of statusListFilter(offer.StatusId)" [(ngValue)]="stype.id">{{stype.description}}</option>
        </select>
        <i></i>
    </label>-->
                  </td>
                  <td>
                    <div *ngIf="offer.FilePath" class="displayinlineblockdiv">
                      <a class="border-link" href={{offer.FilePath}} download="Document.pdf" target="_blank" ng-reflect-placement="top" ng-reflect-tooltip="Download" placement="top" tooltip="Download" triggers="hover">
                        <i aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>LOI
                      </a>
                    </div>
                  </td>

                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="offers?.length == 0 &&!IsLoading">
                  <td colspan="13" class="odd no-data-available">
                    <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Data Available</p>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #template>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Offer Details</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure you want to delete {{deletType}}?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="deleteOffers();modalRef.hide();">Delete</button>
    </div>
  </div>

</ng-template>



<ng-template #notestemplate>
  <app-shared-add-notes (close)="closeModal" [modalRef]="modalRef" [notesInputsModel]="NotesInput"></app-shared-add-notes>
</ng-template>


<ng-template #ChangeStatus class="pull-left">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Change Status</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label class="form-label">Status</label>
      <label class="select">
        <select class="form-control" [(ngModel)]="selectedBulkStatus" #BulkStatus (change)="changeOfferStatus(offer.StatusId,offer.LeadId)">
          <option value="0">--Select--</option>
          <option *ngFor="let stype of statusList" [(ngValue)]="stype.id">{{stype.description}}</option>
        </select>
        <i></i>
      </label>
      <p class="redtext" *ngIf="(selectedBulkStatus == 0 && bulkStatusSubmit) ||(BulkStatus.StateId ==0 && BulkStatus.touched)">Select a status</p>
    </div>
    <div class="text-right">
      <button class="btn btn-default btn-lg" id="closeModal" (click)="modalRef.hide();">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="ChangeSelectedOffersStatus();">Save</button>
    </div>
  </div>

</ng-template>
